import { render, staticRenderFns } from "./Ordernotes.vue?vue&type=template&id=35d02e82&scoped=true"
import script from "./Ordernotes.vue?vue&type=script&lang=js"
export * from "./Ordernotes.vue?vue&type=script&lang=js"
import style0 from "./Ordernotes.vue?vue&type=style&index=0&id=35d02e82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d02e82",
  null
  
)

export default component.exports